import { render, staticRenderFns } from "./LinkUnderlined.vue?vue&type=template&id=20f2151c&scoped=true&"
import script from "./LinkUnderlined.vue?vue&type=script&lang=js&"
export * from "./LinkUnderlined.vue?vue&type=script&lang=js&"
import style0 from "./LinkUnderlined.vue?vue&type=style&index=0&id=20f2151c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f2151c",
  null
  
)

export default component.exports